// Shared constants for the home page.

export const STATS = [
  { value: 2400, suffix: '+', label: 'Projects Shipped' },
  { value: 1500, suffix: '+', label: 'Clients Supported' },
  { value: 99, suffix: '%', label: 'Client Satisfaction' },
  { value: 24, suffix: '/7', label: 'Support Coverage' },
];

export const HERO_WORDS = ['Growth', 'Automation', 'Reliability', 'Scale'];

export const ENGINEERING_SERVICES = [
  {
    icon: 'DP',
    title: 'Digital Product Engineering',
    desc: 'Plan, design, and build web products that are responsive, SEO-ready, fast to launch, and easy to scale.',
    link: '/services',
  },
  {
    icon: 'BA',
    title: 'Business Process Automation',
    desc: 'Connect CRM, APIs, chatbots, and internal tools so teams spend less time on repeat work and more time serving customers.',
    link: '/services',
  },
  {
    icon: 'AI',
    title: 'AI-powered Application Engineering',
    desc: 'Add practical AI features for analytics, automation, support, and decision workflows without overcomplicating the product.',
    link: '/services',
  },
  {
    icon: 'CI',
    title: 'Cloud Infrastructure',
    desc: 'Improve uptime, delivery speed, and protection with CDN setup, WAF rules, server hardening, and performance reviews.',
    link: '/services',
  },
  {
    icon: 'EC',
    title: 'E-commerce Development',
    desc: 'Full-featured online stores with product management, cart, checkout, and bKash, Nagad, or Stripe payment integration.',
    link: '/services',
  },
  {
    icon: 'WL',
    title: 'White-Label & Agency Partner',
    desc: 'Scale delivery without hiring by outsourcing web development, infrastructure support, and urgent fixes under your brand.',
    link: '/services',
  },
  {
    icon: 'LM',
    title: 'Legacy Software Modernization',
    desc: 'Transform outdated systems into modern, scalable solutions with improved performance, security, and maintainability.',
    link: '/services',
  },
  {
    icon: 'MV',
    title: 'MVP Development',
    desc: 'Build and launch minimum viable products quickly to test ideas, gather feedback, and accelerate time-to-market.',
    link: '/services',
  },
  {
    icon: 'SA',
    title: 'SaaS Development',
    desc: 'Create scalable software-as-a-service applications with multi-tenant architecture, subscriptions, and cloud deployment.',
    link: '/services',
  },
  {
    icon: 'IO',
    title: 'IoT Development',
    desc: 'Develop connected devices and IoT platforms with sensor integration, data analytics, and real-time monitoring.',
    link: '/services',
  },
  {
    icon: 'CC',
    title: 'Cloud Computing',
    desc: 'Design cloud-native solutions with microservices, containerization, and serverless computing for maximum scalability.',
    link: '/services',
  },
  {
    icon: 'SM',
    title: 'Support and Maintenance',
    desc: 'Provide ongoing technical support, bug fixes, performance optimization, and feature enhancements for your applications.',
    link: '/services',
  },
];

export const ENGAGEMENT_MODELS = [
  {
    tag: 'For small projects',
    title: 'Staff Augmentation',
    desc: 'Quickly scale your team up and down with focused engineering talent, on demand and without long-term commitment.',
    icon: '01',
    color: '#2563eb',
  },
  {
    tag: 'Fit for products',
    title: 'Dedicated Teams',
    desc: 'We handle onboarding, documentation, project execution, and budget control. Full-stack squads ready to ship your product.',
    icon: '02',
    color: '#059669',
  },
  {
    tag: 'For mid-size',
    title: 'Managed Capacity',
    desc: 'Add scalable engineering capacity under defined SLAs. We manage the team, process, and delivery rhythm.',
    icon: '03',
    color: '#d97706',
  },
  {
    tag: 'For enterprise',
    title: 'White-Label Partner',
    desc: 'A personalized delivery model for agencies and enterprises. Outsource securely under your brand with NDA included.',
    icon: '04',
    color: '#7c3aed',
  },
];

export const CERTIFICATIONS = [
  { label: 'ISO/IEC 27001', sub: 'Information Security' },
  { label: 'ISO 9001', sub: 'Quality Management' },
  { label: 'ISO 14001', sub: 'Environmental Care' },
  { label: 'ISO 45001', sub: 'Health & Safety' },
  { label: 'ISO 37001', sub: 'Anti-Bribery' },
];

export const CASE_STUDIES = [
  {
    tag: 'E-commerce',
    title: 'Multi-Vendor Marketplace',
    desc: 'Built a full-featured marketplace with vendor dashboards, Stripe Connect payouts, and real-time inventory sync.',
    metric: '3x faster',
    metricLabel: 'Order Processing',
    color: '#2563eb',
  },
  {
    tag: 'SaaS',
    title: 'Courier Management SaaS',
    desc: 'Custom logistics platform with real-time tracking, route optimization, and mobile rider app for daily operations.',
    metric: '500+',
    metricLabel: 'Daily Deliveries',
    color: '#059669',
  },
  {
    tag: 'Automation',
    title: 'CRM & Workflow Automation',
    desc: 'Integrated HubSpot CRM with custom Zapier workflows for a Dhaka-based import business.',
    metric: '80%',
    metricLabel: 'Less Manual Work',
    color: '#d97706',
  },
];

export const PARTNERS = ['Google Cloud', 'AWS', 'Microsoft Azure', 'OVHCloud', 'Cloudflare', 'Stripe'];

